import { Platform, StyleSheet, View } from 'react-native';

import { Text, spacing } from '@pletly/ui';
import { MentionText } from '%components/Mentions/MentionText';
import { LinkPreview } from './LinkPreview';

interface Props {
	text?: string | null;
}

export const TextContent = ({ text }: Props) => (
	<View style={styles.content}>
		<Text>
			<MentionText text={text || ''} category={Platform.OS === 'web' ? 'p1' : 's1'} />
		</Text>
		<LinkPreview text={text} />
	</View>
);

export const styles = StyleSheet.create({
	content: {
		marginBottom: spacing(),
		paddingHorizontal: spacing(),
	},
});
